import React from 'react';
import { Switch, Route } from "react-router-dom";
import "./extras.min.css";
import "./dashboard.min.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
/* import Dashboard from "../components/mentoring/Dashboard"; */
import ListaMentores from "../components/mentoring/ListaMentores";
import ListaAlumnos from "../components/mentoring/ListaAlumnos";
import Perfil from "../components/mentoring/Perfil";

function Main() {
    return (
        <>
            <main className="main-content">
                <Navbar />
                
                <Switch>
                    {/* <Route exact path="/mentorias" component={Dashboard} /> */}
                    <Route exact path="/listaMentores" component={ListaMentores} />
                    <Route exact path="/mentorias" component={ListaAlumnos} />
                    <Route exact path="/Perfil" component={Perfil} />
                </Switch>
                
                <Footer />
            </main> 
        </>
    )
}

export default Main
